import { render } from "./EntityManager.vue?vue&type=template&id=17ebb6ca"
import script from "./EntityManager.vue?vue&type=script&lang=js"
export * from "./EntityManager.vue?vue&type=script&lang=js"
script.render = render

export default script